import { IFileAttachment } from '../../../../extViewmodels';
import { isRedrawable } from '../../../components-v2/UnifiedImageDialog/redrawableMedia';

export const isVideoAttachment = (attachment: IFileAttachment) =>
	!!attachment.mimeType?.toLowerCase().startsWith('video/');

/**
 * Branding redraws each image in the account's brand, so it needs images, a brand, and no video beside
 * them. The version bar offers it by the same rule.
 */
export const getRebrandBlockedReason = (media: readonly IFileAttachment[], hasBranding: boolean) => {
	if (!hasBranding) {
		return 'Your account has no brand settings yet';
	}
	if (!media.length) {
		return 'Add an image to apply your branding';
	}
	return media.some(isVideoAttachment) ? 'Branding applies to images, not videos' : undefined;
};

/** A crop redraws a still, so a video or an animated GIF has nothing it can keep. */
export const getCropBlockedReason = (media: readonly IFileAttachment[]) => {
	if (media.some(isRedrawable)) {
		return undefined;
	}
	return media.length ? 'Videos and GIFs can’t be cropped' : 'Add an image to crop it';
};

/** The publisher burns the logo onto images only, never onto a video. */
export const getLogoOverlayBlockedReason = (media: readonly IFileAttachment[]) => {
	if (media.some(attachment => !isVideoAttachment(attachment))) {
		return undefined;
	}
	return media.length ? 'Your logo goes on images, not videos' : 'Add an image to see your logo on it';
};
